import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useState } from "react";
import { Button, CheckPicker, SelectPicker } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  fullDayHourObjArr,
  minSecObjArr,
  playOnExactTimeObjArr,
  weekAllDaysObjArr,
  weekDaysObjArr,
  yesNoObjArr,
} from "../../../core/config/AppConstants";
import {
  isEmptyVal,
} from "../../../utils/helpers";

const AddItemsToCommercialScheduleBulkAction = ({
  commercialScheduleData,
  checkedKeys,
  setCheckedKeys,
  onAddItems,
  onSearchItems,
  selectedTime,
  setSelectedTime,
  selectedDay,
  setSelectedDay,
  onExactTime,
  setOnExactTime,
  ...props
}: {
  commercialScheduleData: any;
  checkedKeys: any;
  setCheckedKeys?: Function;
  onAddItems?: Function;
  onSearchItems?: Function;
  selectedTime?: String;
  setSelectedTime?: Function;
  selectedDay?: String;
  setSelectedDay?: Function;
  onExactTime?: String;
  setOnExactTime?: Function;
}) => {
  const hourToDisplay = fullDayHourObjArr.filter(
    (item) =>
      item.value >= commercialScheduleData.schedule_starts_at &&
      item.value <= commercialScheduleData.schedule_ends_at
  );
  const { t } = useTranslation();

  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [alertDisplayText, setAlertDisplayText] = useState<any>(
    t("PLEASE_SELECT")
  );
  const [selecteDisplaydDay, setSelecteDisplaydDay] = useState<string[]>(
    selectedDay.split(",")
  );
  const [selectedHour, setSelectedHour] = useState<string[]>([]);
  const [selectedMin, setSelectedMin] = useState<string[]>([]);
  const [selectedSec, setSelectedSec] = useState("");
  function clearSelection() {
    setSelectedSec("");
    setSelectedMin([]);
    setSelectedHour([]);
    setSelecteDisplaydDay([]);
    setOnExactTime("");
  }

  function bulkAdd() {
    if (
      commercialScheduleData?.new_schedule_everyday.toString() === "1" &&
      isEmptyVal(selectedDay)
    ) {
      setAlertDisplayText(t("PLEASE_SELECT_FIELD", { field: t("DAY") }));
      setOpenBulkActionNoSelectionModal(true);
      return false;
    }
    if (selectedHour.length < 1) {
      setAlertDisplayText(t("PLEASE_SELECT_FIELD", { field: t("HOUR") }));
      setOpenBulkActionNoSelectionModal(true);
      return false;
    }
    if (selectedMin.length < 1) {
      setAlertDisplayText(t("PLEASE_SELECT_FIELD", { field: t("MINUTE") }));
      setOpenBulkActionNoSelectionModal(true);
      return false;
    }
    if (isEmptyVal(selectedSec)) {
      setAlertDisplayText(t("PLEASE_SELECT_FIELD", { field: t("SECOND") }));
      setOpenBulkActionNoSelectionModal(true);
      return false;
    }
    if (onExactTime === "") {
      setAlertDisplayText(
        t("PLEASE_SELECT_FIELD", {
          field: t("PLAY") + " " + t("ACCURACY"),
        })
      );
      setOpenBulkActionNoSelectionModal(true);
      return false;
    }
    if (checkedKeys.length === 0) {
      setAlertDisplayText(t("PLEASE_SELECT_RECORD_TO_ACTION"));
      setOpenBulkActionNoSelectionModal(true);
      return false;
    }
    onAddItems && onAddItems();
    setSelectedSec("");
    setOnExactTime("");
  }

  function updateSelectedTime(hour = null, min = null, sec = null) {
    let hr = hour === null ? selectedHour : hour;
    let mn = min === null ? selectedMin : min;
    let sc = sec === null ? selectedSec : sec;
    if (hr.length < 1 || mn.length < 1 || sc === "") return;
    let selTime = [];
    let stHr = "";
    hr.forEach(function (valhr: any) {
      stHr = valhr.split(":")[0];
      mn.forEach(function (valmn: any) {
        selTime.push(stHr + ":" + valmn + ":" + sc);
      });
    });
    setSelectedTime(selTime.join(","));
    onSearchItems && onSearchItems({ exclude_start_time: selTime.join(",") });
  }

  const allDayValues = weekDaysObjArr
    .map((day) => day.value)
    .filter((v) => v !== "all");

  const handleOnDayChange = (selectedValues: string[]) => {
    if (selectedValues.includes("all")) {
      // Toggle: If "All Days" is selected, select or deselect all days
      if (selectedValues.length === 8) {
        // All days are selected, so clear the selection
        setSelecteDisplaydDay([]);
        setSelectedDay("");
        onSearchItems?.({ exclude_play_for_day: "" });
      } else {
        // Select all days
        setSelecteDisplaydDay(allDayValues);
        setSelectedDay(allDayValues.join(",").replace(/^[, ]+|[, ]+$/g, ""));
        onSearchItems?.({
          exclude_play_for_day: allDayValues
            .join(",")
            .replace(/^[, ]+|[, ]+$/g, ""),
        });
      }
    } else {
      // Update selected days normally (without "All Days")
      setSelecteDisplaydDay(selectedValues);
      setSelectedDay(selectedValues.join(",").replace(/^[, ]+|[, ]+$/g, ""));
      onSearchItems?.({
        exclude_play_for_day: selectedValues
          .join(",")
          .replace(/^[, ]+|[, ]+$/g, ""),
      });
    }
  };

  const handleOnHourChange = (selectedValues: string[]) => {
    setSelectedHour(selectedValues);
    updateSelectedTime(selectedValues);
  };

  const handleOnMinChange = (selectedValues: string[]) => {
    setSelectedMin(selectedValues);
    updateSelectedTime(null, selectedValues);
  };

  return (
    <div className="add-items-commercial-toolbar">
      {UtilityServices.hasPermission("delete-item") && (
        <>
          <Button
            appearance="primary"
            className="add-items-commercial-toolbar-btn add-items-commercial-add-btn"
            onClick={bulkAdd}
          >
            {t("ADD")} {t("ITEMS")} {t("TO")}
          </Button>

          {commercialScheduleData?.new_schedule_everyday &&
            commercialScheduleData?.new_schedule_everyday.toString() ===
              "1" && (
              <div className="add-items-commercial-picker-wrap">
                <CheckPicker
                  sticky
                  className="add-items-commercial-picker"
                  onChange={handleOnDayChange}
                  onClean={() => {
                    setSelectedDay("");
                    onSearchItems &&
                      onSearchItems({ exclude_play_for_day: "" });
                  }}
                  data={weekAllDaysObjArr}
                  value={selecteDisplaydDay}
                  name="play_for_day"
                  placeholder={t("DAY")}
                />
              </div>
            )}
          <div className="add-items-commercial-picker-wrap add-items-commercial-picker-sm">
            <CheckPicker
              sticky
              className="add-items-commercial-picker"
              onChange={handleOnHourChange}
              onClean={() => {
                setSelectedHour([]);
                updateSelectedTime([]);
              }}
              data={hourToDisplay}
              value={selectedHour}
              name="slot_hour"
              placeholder={t("HOUR")}
            />
          </div>
          <div className="add-items-commercial-picker-wrap add-items-commercial-picker-sm">
            <CheckPicker
              sticky
              className="add-items-commercial-picker"
              onChange={handleOnMinChange}
              onClean={() => {
                setSelectedMin([]);
                updateSelectedTime(null, []);
              }}
              data={minSecObjArr}
              value={selectedMin}
              name="slot_min"
              placeholder={t("MINUTE")}
            />
          </div>
          <div className="add-items-commercial-picker-wrap add-items-commercial-picker-sm">
            <SelectPicker
              className="add-items-commercial-picker"
              data={minSecObjArr}
              valueKey="value"
              labelKey="label"
              onSelect={(value, item, e) => {
                setSelectedSec(value);
                updateSelectedTime(null, null, value);
              }}
              onClean={(e: any) => {
                setSelectedSec("");
                updateSelectedTime(null, null, "");
              }}
              name="slot_sec"
              placeholder={t("SECOND")}
              value={selectedSec}
            />
          </div>
          <div className="add-items-commercial-picker-wrap">
            <SelectPicker
              className="add-items-commercial-picker"
              data={playOnExactTimeObjArr}
              valueKey="value"
              labelKey="label"
              onSelect={(value, item, e) => {
                setOnExactTime(value);
              }}
              onClean={(e: any) => {
                setOnExactTime("");
              }}
              name="on_exact_time"
              placeholder={t("PLAY") + " " + t("ACCURACY")}
              value={onExactTime}
            />
          </div>
          <Button
            appearance="subtle"
            className="add-items-commercial-toolbar-btn"
            onClick={clearSelection}
          >
            {t("CLEAR")} {t("SELECTION")}
          </Button>
        </>
      )}
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={alertDisplayText}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />
    </div>
  );
};

export default AddItemsToCommercialScheduleBulkAction;
